import React from 'react';
// TODO: refactor this
// eslint-disable-next-line
import { useAsObservableSource } from 'mobx-react-lite';
import { observer } from 'src/utils/mobx-react';
import { EventGroupHeader6Pack } from 'src/domains/sportsbook/webview/components/eventsList/eventGroupHeader6Pack/EventGroupHeader6Pack';
import { getMarketNameNFL } from 'src/domains/layouts/shared/translations/markets';
import { useCommon } from 'src/domains/common/Common';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';

interface EventGroupHeaderPropsType {
    dataTest?: string;
    label: string;
    onToggle: () => void;
    open: boolean;
}

export const EventGroupHeaderNFL = observer('EventGroupHeaderNFL', (propsIn: EventGroupHeaderPropsType) => {
    const common = useCommon();
    const languagesState = LanguagesState.get(common);
    const props = useAsObservableSource(propsIn);
    const { dataTest, label, open, onToggle } = props;

    return (
        <EventGroupHeader6Pack
            dataTest={dataTest}
            label={label}
            marketNames={getMarketNameNFL(languagesState.getTranslation)}
            onToggle={onToggle}
            open={open}
        />
    );
});
